module.exports = __webpack_public_path__ + "media/images/pc/stores/common/instagram/photographer_sns_04-038ce850b2d1668233bc23780a522a80.jpg";